module.exports = __webpack_public_path__ + "static/img/5.6cf8751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/5.png
// module id = Zezw
// module chunks = 0